import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseMessaging, GetTokenOptions } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  options: GetTokenOptions = {
    vapidKey: environment.firebase.vapidKey,
  };

  constructor(private router: Router) {}

  public async init() {
    try {
      this.addListeners();

      // Si richiede all'utente il permesso ad utilizzare le notifiche
      await FirebaseMessaging.requestPermissions();
      // Per ottenere il token del dispositivo web?
      if (Capacitor.getPlatform() === 'web') {
        this.options.serviceWorkerRegistration =
          await navigator.serviceWorker.register('firebase-messaging-sw.js');
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Ottiene il token del dispositivo mobile
   */
  public async getToken() {
    return (await FirebaseMessaging.getToken(this.options)).token;
  }

  public async removeToken() {
    FirebaseMessaging.deleteToken();
  }

  private addListeners() {
    Capacitor.getPlatform() === 'web'
      ? this.addWebListeners()
      : this.addMobileListeners();
  }

  private addMobileListeners() {
    // Cosa succede quando arriva una notifica e l'app è aperta
    FirebaseMessaging.addListener('notificationReceived', (event) => {
    });
    // Cosa succede quando uno preme sopra la notifica
    FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      const data = (event as any)?.notification?.data ?? {};
      this.routeFromNotification(data);
    });
  }

  private addWebListeners() {
    navigator.serviceWorker.addEventListener('message', (event: any) => {
      const notification = new Notification(event.data.notification.title, {
        body: event.data.notification.body,
      });
      notification.onclick = () => {
        this.routeFromNotification(event.data?.data ?? {});
      };
    });
  }

  /** routing basato sul payload "data" della notifica FCM (tipologia) */
  private routeFromNotification(data: any) {
    switch (data?.tipologia) {
      case 'chat-veterinaria':
        this.router.navigate(['/chat']);
        break;
      default:
        this.router.navigate(['/tabs/home']);
    }
  }
}
